/*
* ©2016 Matthew Bergsma, Gravit Digital. All Rights Reserved.
*  May not be redistrubted without permission
*/
(function(Backbone, _, $) {
	

	/* ------------------------------------------------------------------------
	 * GalleryView
	 */
	var MenuView = Backbone.View.extend({
		active: false,
		el: "#site-header .menu--main",
		events: {
			'click >.menu>.menu-item--expanded>a': '_click',			
			'click >.menu>.menu-item--expanded>span': '_click',			
		},

		initialize: function(options) {			
			_.bindAll(this, '_click');	
			$('html').addClass('js-menu');
		},

		render: function() {
		},

		_click: function(e) {	
			e.preventDefault();
			var view = this;
			var $p = $(e.currentTarget).parent();
			view.$el.find('.js-active').not($p).removeClass('js-active');
			
			if ($p.hasClass('js-active')) {
				$p.removeClass('js-active');
				$('#menu-drawer').removeClass('active').slideUp(250);
			} else {
				$p.addClass('js-active');				
				$('#menu-drawer').hide().html('<div class="outer-wrapper"><ul class="menu">'+$p.find('.menu').clone().html()+'</ul></div>').addClass('active').slideDown(250);				
			}	
		}		

	});

	var menu = new MenuView();
		

})(Backbone, _, jQuery);